var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"userNameColor",style:({ color: _vm.activeColor, fontWeight: _vm.fontWeight })},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }